import { Component, ElementRef, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { AppAuthService } from '@shared/auth/app-auth.service';
import { NotificationServiceProxy, ReminderNotificationDto, ReminderServiceProxy } from '@shared/service-proxies/service-proxies';
import { NotificationCountUpdatedService } from "@shared/helpers/notification-count-updated.service";
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { ReminderCountUpdatedService } from '@shared/helpers/reminder-count-updated.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.css']
})
export class RightMenuComponent extends AppComponentBase implements OnInit {
  numberNotifications: number = 0;
  numberReminders: number = 0;
  notificationCountUpdatedService: NotificationCountUpdatedService;
  reminderCountUpdatedService: ReminderCountUpdatedService;
  @ViewChild('popTemplate', { static: true }) popTemplate;
  @ViewChild('calendarPopover', { static: false }) calendarPopover: PopoverDirective;
  @ViewChild('notificationPopover', { static: false }) notificationPopover: PopoverDirective;
  @ViewChild('reminderPopover', { static: false }) reminderPopover: PopoverDirective;
  @ViewChild('notificationIcon', { static: false }) notificationIcon: ElementRef;

  isNotificationPopoverOpen = false;
  isReminderPopoverOpen = false;
  tooltipsVisible: { [key: string]: boolean } = {};
  isToggling: boolean = false;

  isProduction: boolean = (environment.appConfig == 'appconfig.production.json' || environment.appConfig == 'appconfig.staging.json');

  constructor(injector: Injector,
    private _authService: AppAuthService,
    private _notificationService: NotificationServiceProxy,
    private _reminderService: ReminderServiceProxy,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    super(injector);
    this.notificationCountUpdatedService = injector.get(NotificationCountUpdatedService);
    this.reminderCountUpdatedService = injector.get(ReminderCountUpdatedService);
  }

  ngOnInit() {
    this.notificationCountUpdatedService.notification.subscribe((x) => {
      this._notificationService.getUnreadNotificationsCount()
        .subscribe((result: number) => {
          this.numberNotifications = result;
        });
    });
    this.reminderCountUpdatedService.reminder.subscribe((x) => {
      this._reminderService.getUnreadReminderNotificationsByUserId(this.appSession.userId)
        .subscribe((result: ReminderNotificationDto[]) => {
          this.numberReminders = result.length;
        });
    });
  }

  toggleCalendar(dp: BsDatepickerDirective) {
    this.hideAllTooltips();
    dp.toggle();
  }

  showTooltip(key: string) {
    this.tooltipsVisible[key] = true;
  }

  hideTooltip(key: string) {
    this.tooltipsVisible[key] = false;
  }

  toggleTooltip(key: string) {
    this.tooltipsVisible[key] = !this.tooltipsVisible[key];
  }

  logout(): void {
    this.hideAllTooltips();
    abp.message.confirm(
      this.l('AreYouSureWantToLogout'),
      undefined,
      (result: boolean) => {
        if (result) {
          this._authService.logout();
        }
      }
    );
  }

  redirectUserConfiguration() {
    this.hideAllTooltips();
    this.router.navigate(['/app/settings/user-settings'])
  }

  toggleNotificationPopover(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.closeReminderPopover();

    if (!this.notificationPopover) return;

    if (this.isNotificationPopoverOpen) {
        this.closeNotificationPopover();
    } else {
        this.openNotificationPopover();
    }
  }

  openNotificationPopover() {
      this.isNotificationPopoverOpen = true;
      this.notificationPopover.show();
  }

  closeNotificationPopover() {
      this.isNotificationPopoverOpen = false;
      this.notificationPopover.hide();
  }

  toggleReminderPopover(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.closeNotificationPopover();

    if (!this.reminderPopover) return;

    if (this.isReminderPopoverOpen) {
        this.closeReminderPopover();
    } else {
        this.openReminderPopover();
    }
  }

  openReminderPopover() {
      this.isReminderPopoverOpen = true;
      this._reminderService.getUnreadReminderNotificationsByUserId(this.appSession.userId)
      .subscribe((result: ReminderNotificationDto[]) => {
        this.numberReminders = result.length;
      });
      this.reminderPopover.show();
  }

  closeReminderPopover() {
      this.isReminderPopoverOpen = false;
      this.reminderPopover.hide();
  }

  hideAllTooltips() {
    this.tooltipsVisible = {
      calendar: false,
      notifications: false,
      userPreferences: false,
      logout: false
    };
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (this.notificationIcon) {
      const clickedInsideIcon = this.notificationIcon.nativeElement.contains(targetElement);
      const popoverContainer = document.querySelector('.popover.show');

      if (!clickedInsideIcon && popoverContainer && !popoverContainer.contains(targetElement)) {
        this.notificationPopover.hide();
        this.reminderPopover.hide();
        this.isNotificationPopoverOpen = false;
        this.isReminderPopoverOpen = false;
      }
    }
  }

  onClosePopover(): void {
    this.notificationPopover.hide();
    this.reminderPopover.hide();
    this.isNotificationPopoverOpen = false;
    this.isReminderPopoverOpen = false;
  }
}
